export enum SESSIONACTION {
  CREATE = 'create',
  INFO = 'info',
  UPDATE = 'update',
  DELETE_SESSION_TOKEN = 'delete token',
  DELETE_SESSION_USER_DATA = 'delete user data',

}
